import React from 'react';
import { Link } from 'react-router-dom';

export const DroneSoccerSolutions = () => {
  return (
    <section className="soccer-solutions-section">
      <h2 className="soccer-solutions-title">DRONE SOCCER SOLUTIONS</h2>
      <p className="soccer-solutions-description">
        Discover the thrill of drone soccer with premium equipment, full-on
        support, and a curriculum designed to inspire. Contact us today to start
        your team’s winning journey.
      </p>
      <div className="dreamX__discover--button">
        <Link
          to="/contact?product=drone-soccer"
          rel="noopener noreferrer"
          className="btn btn--primary btn--med"
          onMouseDown={event => event.preventDefault()}
        >
          get in touch
        </Link>
      </div>
    </section>
  );
};
